import { Button, Checkbox, Col, Input, Row } from 'antd';
import { Loader } from 'components/Global';
import Ellipse from 'components/Global/Ellipse';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import styles from './index.module.scss';
import './index.scss';
import { EarningsModalProps } from './type';

const MasterEarningsModal: React.FC<EarningsModalProps> = ({
	onDataChange,
	isLoading,
	activeTab,
	isUSD,
	fetchMasterEarnings,
	data,
	setData,
}) => {
	const [earningsData, setEarningsData] = useState<any>();
	const [showAll, setShowAll] = useState<boolean>(false);

	const { data: profileData } = useSelector(
		(state: any) => state?.userProfile
	);

	const { baseCurrencySymbol, usdCurrencySymbol } = profileData;

	const updateData = (newData: any) => {
		setEarningsData(newData);
		onDataChange(newData);
	};

	const handleChange = (index: string, value: string | boolean) => {
		let newData;
		if (typeof value === 'boolean') {
			newData = data.map((item: any) => {
				if (item.id === index) {
					return { ...item, isChecked: value };
				}
				return item;
			});
		} else {
			newData = data.map((item: any) => {
				if (item.id === index) {
					return {
						...item,
						isChanged: true,
						amount: isNaN(parseFloat(value))
							? parseFloat('0.00')
							: value,
					};
				}
				return item;
			});
		}
		setData(newData);
		updateData(newData);
	};

	const handleBlur = (index: number) => {
		const newData = data.map((item: any) => {
			if (item.id === index) {
				return {
					...item,
					amount:
						isNaN(item.amount) || item.amount < 0
							? '0.00'
							: parseFloat(item.amount).toFixed(2),
				};
			}
			return item;
		});
		setData(newData);
		updateData(newData);
	};

	const renderItems = (items: any) =>
		items?.map((item: any) => (
			<Col key={item.id} span={12}>
				<div className={styles.earningsFields}>
					<div className="checkbox">
						<Checkbox
							checked={item.isChecked}
							onChange={() =>
								handleChange(item?.id, !item.isChecked)
							}
						/>
					</div>
					<label className={styles.label}>
						<Ellipse
							maxLength={20}
							message={item?.description}
							isTooltip={true}
							tooltipMessage={item?.description}
							key={item?.description}
						/>
					</label>
					<div className={styles.inputContainer}>
						<Input
							value={item?.amount ?? 0}
							onChange={(e) =>
								handleChange(item?.id, e.target.value)
							}
							onBlur={() => handleBlur(item?.id)}
							type="number"
							suffix={
								isUSD ? usdCurrencySymbol : baseCurrencySymbol
							}
							disabled={item.isDisable}
							className={styles.input}
						/>
					</div>
				</div>
			</Col>
		));

	const toggleShowAll = () => {
		setShowAll(!showAll);
	};

	const topPriorityItems = earningsData?.slice(0, 12) || [];
	const nonDefaultItems = showAll ? earningsData?.slice(12) : [];

	useEffect(() => {
		setEarningsData(data);
	}, [data]);

	useEffect(() => {
		onDataChange(data);
	}, [data]);

	useEffect(() => {
		if (activeTab === 'earnings') {
			fetchMasterEarnings();
		}
	}, [activeTab]);

	return (
		<div className="earningsFields">
			{isLoading ? (
				<div
					style={{
						display: 'flex',
						justifyContent: 'center',
						alignItems: 'center',
						height: '50vh',
					}}
				>
					<Loader />
				</div>
			) : (
				<>
					<div className={styles.earningItems}>
						<Row gutter={12}>{renderItems(topPriorityItems)}</Row>
						<Row gutter={12} className="extra-earnings">
							{/* {!showAll && ( */}
							<hr
								className="color-purple"
								style={{
									width: '100vw',
									marginBottom: '20px',
								}}
							/>
							{/* )} */}
							{renderItems(nonDefaultItems)}
						</Row>
						<Row>
							<Col span={24}>
								<p style={{ float: 'right' }}>
									<Button
										style={{ border: 'none' }}
										className={styles.showMoreLink}
										onClick={toggleShowAll}
									>
										{showAll ? 'Show Less' : 'Show More'}
									</Button>
								</p>
							</Col>
						</Row>
					</div>
				</>
			)}
		</div>
	);
};

export default MasterEarningsModal;
